import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e78c88c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Card" }
const _hoisted_2 = { class: "layout" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "btn-group" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-upload",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z" })
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-search",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" })
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-pencil-square",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
  })
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-trash3",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" })
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "col" }
const _hoisted_20 = { class: "btn-group" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-caret-right-fill",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" })
], -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-rewind-fill",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8.404 7.304a.802.802 0 0 0 0 1.392l6.363 3.692c.52.302 1.233-.043 1.233-.696V4.308c0-.653-.713-.998-1.233-.696z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M.404 7.304a.802.802 0 0 0 0 1.392l6.363 3.692c.52.302 1.233-.043 1.233-.696V4.308c0-.653-.713-.998-1.233-.696z" })
], -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["disabled"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-skip-start-fill",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M4 4a.5.5 0 0 1 1 0v3.248l6.267-3.636c.54-.313 1.232.066 1.232.696v7.384c0 .63-.692 1.01-1.232.697L5 8.753V12a.5.5 0 0 1-1 0z" })
], -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = ["disabled"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-skip-end-fill",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12.5 4a.5.5 0 0 0-1 0v3.248L5.233 3.612C4.693 3.3 4 3.678 4 4.308v7.384c0 .63.692 1.01 1.233.697L11.5 8.753V12a.5.5 0 0 0 1 0z" })
], -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { class: "container" }
const _hoisted_34 = {
  class: "row",
  style: {"gap":"20px"}
}
const _hoisted_35 = {
  class: "col-10 d-flex flex-column justify-content-center align-items-center",
  style: {"gap":"50px"}
}
const _hoisted_36 = { class: "row" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Catálogo de Clientes", -1))
const _hoisted_38 = { class: "row mb-1" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Cliente", -1))
const _hoisted_40 = { class: "col-sm-2" }
const _hoisted_41 = ["readonly"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Estado", -1))
const _hoisted_43 = { class: "col-sm-2" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "A" }, "Activo", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "I" }, "Inactivo", -1))
const _hoisted_47 = { class: "row mb-1" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Tipo Cliente", -1))
const _hoisted_49 = { class: "col-sm-2" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "J",
  selected: ""
}, "Jurídico", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "N" }, "Natural", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Nombre Comercial", -1))
const _hoisted_54 = { class: "col-sm-7" }
const _hoisted_55 = ["readonly"]
const _hoisted_56 = { class: "row mb-1" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Razón Social", -1))
const _hoisted_58 = { class: "col-sm-5" }
const _hoisted_59 = ["readonly"]
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Ruc", -1))
const _hoisted_61 = { class: "col-sm-3" }
const _hoisted_62 = ["readonly"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Dv.", -1))
const _hoisted_64 = { class: "col-sm-1" }
const _hoisted_65 = ["readonly"]
const _hoisted_66 = { class: "row mb-1" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword4",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Dirección", -1))
const _hoisted_68 = { class: "col-sm-6" }
const _hoisted_69 = ["readonly"]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Ubicación", -1))
const _hoisted_71 = { class: "col-sm-2" }
const _hoisted_72 = ["readonly"]
const _hoisted_73 = { class: "row mb-1" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword4",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Email", -1))
const _hoisted_75 = { class: "col-sm-6" }
const _hoisted_76 = ["readonly"]
const _hoisted_77 = { class: "row mb-1" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword3",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Teléfono #1", -1))
const _hoisted_79 = { class: "col-sm-2" }
const _hoisted_80 = ["readonly"]
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword2",
  class: "col-sm-1 col-form-label col-form-label-sm"
}, "Teléfono #2", -1))
const _hoisted_82 = { class: "col-sm-2" }
const _hoisted_83 = ["readonly"]
const _hoisted_84 = {
  class: "col",
  style: {"background-color":"rgba(255, 255, 255, 0.3)","backdrop-filter":"blur(10px)","border-radius":"10px"}
}
const _hoisted_85 = { class: "btn-group2" }
const _hoisted_86 = ["disabled"]
const _hoisted_87 = ["disabled"]

import { ref, watch, computed,onMounted } from 'vue'
import axios from 'axios';
import { useAlert } from '@/store/useAlert';
import { UrlGlobal } from '@/store/dominioGlobal';
import { userGlobalStore } from '@/store/userGlobal';
import { useDateTimeStore } from '@/store/dateTimeStore';
import { RefSymbol } from '@vue/reactivity';


export default /*#__PURE__*/_defineComponent({
  __name: 'CrmClte',
  setup(__props) {

const { success, error, question, warning } = useAlert()
const dUrl = UrlGlobal()
const userStore = userGlobalStore()
const dateTimeStore = useDateTimeStore();

//--------------------------------------------------------------------------------------------------------------
// Estado del formulario y la data
const formData = ref({
  cliente: '',
  code_id: '',
  status: '',
  nombre_comercial: '',
  razon_social: '',
  id_legal: '',
  digito_vf: '',
  ubicacion: '',
  barrio: '',
  telefono1: '',
  telefono2: '',
  email: '',
});

// Variables de control
const dataList = ref<any[]>([]); // Lista de datos de la API
const currentIndex = ref(0);
const isEditing = ref(false);
const isSearching = ref(false);
const isInserting = ref(false);
const isDeleting = ref(false)
const canNavigate = ref(false);
const onlyRead = ref(true);
const tonlyRead = ref(true);
const ButtonText = ref('OK')
const ButtonText2 = ref('Cancelar')

// Deshabilita los botones de btn-group2 si no está en modo búsqueda o insercion
const canUseGroup2 = computed(() => isSearching.value || isInserting.value || isEditing.value || isDeleting.value);

//------------------------------------------------------------------------------------------------------------------

//Funciones---------------------------------------------------------------------------------------------------------
// Función para iniciar inserción
const startInsert = () => {
  isInserting.value = true;
  isSearching.value = false;
  isEditing.value = false;
  isDeleting.value = false;
  onlyRead.value = false;
  tonlyRead.value = false
  ButtonText.value = 'Insertar';
  formData.value.status = 'A'
  formData.value.code_id ='J'
};

// Función para iniciar búsqueda
const startSearch = () => {
  isSearching.value = true;
  isInserting.value = false;
  isEditing.value = false;
  isDeleting.value = false;
  onlyRead.value = false;
};

// Funcion para iniciar edición
let pk: string
const startUpdate = () => {
  isEditing.value = true;
  isInserting.value = false;
  isSearching.value = false;
  isDeleting.value = false;
  canNavigate.value = false;
  onlyRead.value = false;
  ButtonText.value = 'Editar';
  ButtonText2.value = 'Volver';
  pk = formData.value.cliente
};

//funcion para iniciar eliminacion
const starDelete = () => {
  isDeleting.value = true;
  isEditing.value = false;
  isInserting.value = false;
  isSearching.value = false;
  canNavigate.value = false;
  onlyRead.value = true;
  ButtonText.value = 'Eliminar';
  ButtonText2.value = 'Volver'
};


// Función para hacer la consulta
const handleSearch = async () => {
  try {
    const response = await axios.post(dUrl.urlGlobal + '/api2/query', { tabla: 'crmclte', filtro: formData.value });
    dataList.value = response.data;
    currentIndex.value = 0;
    updateFormData();

    if (dataList.value.length === 0) {
      warning('No se ha encontrado registros con los datos ingresados', 'Vuelva hacer la consulta')
      ButtonText.value = 'Ok';
    } else {
      ButtonText.value = 'Consulta';
      canNavigate.value = true;
      onlyRead.value = true;
    }
  } catch (err: any) {
    error(err.response?.data?.detail || 'Ocurrió un error en la consulta.')
  }
};

 

//Funcion para la insercion
const handleInsert = async () => {
  let vali = 0

// Validar Campos
  if(!formData.value.cliente){
    error('Digite el código del Cliente')
    return
  }

  if (!formData.value.nombre_comercial) {
    error('Digite el nombre comercial... ')
    return
  }

  if (!formData.value.code_id) {
    error('Defina el tipo de cliente... ')
    return
  }

  if (!formData.value.razon_social) {
    error('Digite la razón social del cliente... ')
    return
  }

  if (!formData.value.id_legal) {
    error('Digite el Ruc o cédula... ')
    return
  }

  if (!formData.value.digito_vf) {
    error('Debe digitar el dígito verificador... ')
    return
  }

  if (!formData.value.email) {
    error('Tiene que digitar el correo electrónico...')
    return
  }
  if (!formData.value.status) {
    error('Estado del Cliente incorrecto...')
    return
  }

  if (!formData.value.telefono1 && !formData.value.telefono2) {
    error('Debe digitar al menos un número telefónico... ')
    return
  }

 
  // VALIDA REGISTRO DUPLICADO
  try {
    const response = await axios.post(dUrl.urlGlobal + '/api2/query', { tabla: 'crmclte', 
        filtro: { id_legal: formData.value.id_legal}});

    dataList.value = response.data;

    if (dataList.value.length > 0) {
      warning('Este Ruc o cédula ya existe... ', 'valide la Información')
      return
    }

    } catch (err: any) {
        error(err.response?.data?.detail || 'Ocurrió un error en la consulta.')
  }

  const result = await question(
    'Se va a insertar el campo con los nuevos datos.',
    '¿Deseas insertar este registro?'
  )

  if (!result.isConfirmed) {
    // Usuario canceló, salimos de la función
    return
  }

  const data = {
    model: "crmclte",
    data: {
      cliente: formData.value.cliente,
      nombre_comercial: formData.value.nombre_comercial,
      code_id: formData.value.code_id,
      id_legal: formData.value.id_legal,
      digito_vf: formData.value.digito_vf,
      razon_social: formData.value.razon_social,
      ubicacion: formData.value.ubicacion,
      barrio: formData.value.barrio,
      telefono1: formData.value.telefono1,
      telefono2: formData.value.telefono2,
      email: formData.value.email,
      status: formData.value.status,
      creado_por: userStore.globalUser,
      fecha_creado: dateTimeStore.formattedDate,
      hora_creado: dateTimeStore.formattedTime
    }
  }
  try {
    const response = await fetch(dUrl.urlGlobal + '/api2/insert/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })

    if (!response.ok) {
      error('Ocurrió un error al insertar los datos del Cliente', 'Formulario')
    }
    else {
      vali++     
    } 
  } catch (err: any) {
        error(err.response?.data?.detail || 'Error al tratar de Insertar... ')
    }

  if (vali > 0) {
    success('Los datos fueron insertados correctamente.', 'Registro exitoso')
  }
}

//funcion para el update
const handleUpdate = async () => {
  // Mostrar confirmación
  const result = await question(
    'Se va a actualizar el campo con los nuevos datos.',
    '¿Deseas actualizar este registro?'
  )

  if (!result.isConfirmed) {
    // Usuario canceló, salimos de la función
    return
  }

  try {
    const response = await axios.post(dUrl.urlGlobal + '/api2/update/', {
      table: 'crmclte',
      filters: { cliente: formData.value.cliente }, // Filtro para identificar el registro a actualizar
      data: {
      cliente: formData.value.cliente,
      nombre_comercial: formData.value.nombre_comercial,
      code_id: formData.value.code_id,
      id_legal: formData.value.id_legal,
      digito_vf: formData.value.digito_vf,
      razon_social: formData.value.razon_social,
      ubicacion: formData.value.ubicacion,
      barrio: formData.value.barrio,
      telefono1: formData.value.telefono1,
      telefono2: formData.value.telefono2,
      email: formData.value.email,
      status: formData.value.status,
      creado_por: userStore.globalUser,
      fecha_creado: dateTimeStore.formattedDate,
      hora_creado: dateTimeStore.formattedTime
    } // Datos a actualizar
    })
    if (response.status == 200) {
      success('Los datos fueron actualizados correctamente.', 'Actualización exitosa')
    } else {
      error('Ocurrió un error al actualizar los datos.')
    }
  } catch (err: any) {
    error(err.response?.data?.detail || 'Ocurrió un error al actualizar los datos.')
  }
}

//funcion para eliminar
const handleDelete = async () => {
 // Mostrar confirmación
  const result = await question(
    'Se va inactivar el registro.',
    '¿Deseas inhabilitar a este registro?'
  )

  if (!result.isConfirmed) {
    // Usuario canceló, salimos de la función
    return
  }

  try {
    const response = await axios.post(dUrl.urlGlobal + '/api2/update/', {
      table: 'crmclte',
      filters: { cliente: formData.value.cliente }, // Filtro para identificar el registro a actualizar
      data: {
        status: 'I',
      }
    })
    if (response.status == 200) {
      success('el registro fue inhabilitado correctamente.', 'Accion exitosa')
    } else {
      error('Ocurrió un error al inactivar el registro.')
    }
  } catch (err: any) {
    error(err.response?.data?.detail || 'Ocurrió un error inesperado.')
  }
}

// Actualiza el formulario con el registro actual
const updateFormData = () => {
  if (dataList.value.length > 0) {
    formData.value = { ...dataList.value[currentIndex.value] };
  }
};
     
//carga de las ayudas
const operadores = ref<any[]>([]);
const aeronaves = ref<any[]>([]);
const puertos = ref<any[]>([]);
const naturaleza = ref<any[]>([]);
onMounted(async () => {
  const responseO = await axios.get(dUrl.urlGlobal + '/api2/caropera/')
  operadores.value = responseO.data
  const responseA = await axios.get(dUrl.urlGlobal + '/api2/cartiaero/')
  aeronaves.value = responseA.data
  const responseP = await axios.get(dUrl.urlGlobal + `/api2/puertos/filter?status=A`)
  puertos.value = responseP.data
  const responseN = await axios.get(dUrl.urlGlobal + '/api2/naturaleza/filter?status=A')
  naturaleza.value = responseN.data
})

//computados de las ayudas
const descripcionOperador = computed(() => {
  const encontrado = operadores.value.find(op => op.operador === formData.value)
  return encontrado ? encontrado.nombre : ''
})

const descripcionAeronaves = computed(() => {
  const encontrado = aeronaves.value.find(i => i.aeronave === formData.value)
  return encontrado ? encontrado.descripcion : ''
})

const descripcionPuertosDP = computed(() => {
  const encontrado = puertos.value.find(i => i.puerto === formData.value)
  return encontrado ? encontrado.nombre : ''
})

const descripcionPuertosDT = computed(() => {
  const encontrado = puertos.value.find(i => i.puerto === formData.value)
  return encontrado ? encontrado.nombre : ''
})

const descripcionNaturaleza = (naturalezaId: string) => {
  const encontrado = naturaleza.value.find(i => i.aeronave === naturalezaId)
  return encontrado ? encontrado.nombre : ''
}

let idnaturaleza : any
const idN = (naturalezaId: string) => {
  idnaturaleza = naturalezaId
}
//const descripcionNaturaleza = computed(() => {
//  const encontrado = naturaleza.value.find(i => i.naturaleza === registros.value.)
//  return encontrado ? encontrado.nombre
//})
//------------------------------------------------------------------------------------------------------------------

// Navegación entre registros---------------------------------------------------------------------------------------
const goToFirst = () => {
  currentIndex.value = 0;
  updateFormData();
};
const goToPrev = () => {
  if (currentIndex.value > 0) {
    currentIndex.value--;
    updateFormData();
  }
};
const goToNext = () => {
  if (currentIndex.value < dataList.value.length - 1) {
    currentIndex.value++;
    updateFormData();
  }
};
const goToLast = () => {
  currentIndex.value = dataList.value.length - 1;
  updateFormData();
};
//------------------------------------------------------------------------------------------------------------------

// Control de botones submit y cancelar-----------------------------------------------------------------------------------------------

//boton principal que controla el submit
const toggleSearch = () => {
  if (dataList.value.length && isSearching.value == true) {
    // Si ya hay datos, "Consulta" limpia y reinicia la búsqueda
    dataList.value = [];
    formData.value = { cliente: '', nombre_comercial: '', razon_social: '', id_legal: '', code_id: '', status: '', 
                      telefono1: '', telefono2: '', email: '', ubicacion: '', digito_vf: '', barrio: '', };
    onlyRead.value = false;
    ButtonText.value = 'Ok'
    canNavigate.value = false;
  } else if (isInserting.value == true) {
    handleInsert();
  } else if (isEditing.value == true) {
    handleUpdate();
  } else if (isDeleting.value == true) {
    handleDelete()
  }
  else {
    // Si no hay datos, hace la consulta
    handleSearch();
  }
};


// Boton que restablece todo a estado inicial
const resetAll = () => {
  if (ButtonText2.value == 'Cancelar') {
    dataList.value = [];
    formData.value = { cliente: '', nombre_comercial: '', code_id: '', razon_social: '', id_legal: '', status: '', 
                        digito_vf: '', ubicacion: '', barrio: '', telefono1: '', telefono2: '', email: ''};
    isInserting.value = false;
    isSearching.value = false;
    isEditing.value = false;
    isDeleting.value = false;
    canNavigate.value = false;
    onlyRead.value = true;
    tonlyRead.value = true;
    ButtonText.value = 'Ok'
  } else {
    dataList.value = [];
    formData.value = { cliente: '', nombre_comercial: '', code_id: '', id_legal: '', digito_vf: '', razon_social: '', 
                      status: '', ubicacion: '', barrio: '', telefono1: '', telefono2: '', email: '' };
    startSearch()
    ButtonText.value = 'Ok'
    ButtonText2.value = 'Cancelar'
  }
};
//---------------------------------------------------------------------------------------------------------------------------------------------------------


//control de filas automaticas de la tabla-----------------------------------------------------------------------------------------------------------------

// Función para validar si una fila está completamente llena
 

// Observar el último elemento y agregar uno nuevo si está lleno
 
  

  // Evaluar la última fila
//-----------------------------------------------------------------------------------------------------------------------------------------------------------

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("body", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  class: "btn-insert",
                  onClick: startInsert,
                  disabled: isSearching.value || isEditing.value || isDeleting.value
                }, _hoisted_9, 8, _hoisted_7),
                _createElementVNode("button", {
                  class: "btn-search",
                  onClick: startSearch,
                  disabled: isInserting.value || isEditing.value || isDeleting.value
                }, _hoisted_12, 8, _hoisted_10),
                _createElementVNode("button", {
                  class: "btn-update",
                  onClick: startUpdate,
                  disabled: !canNavigate.value
                }, _hoisted_15, 8, _hoisted_13),
                _createElementVNode("button", {
                  class: "btn-delete",
                  onClick: starDelete,
                  disabled: !canNavigate.value
                }, _hoisted_18, 8, _hoisted_16)
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  class: "btn-next",
                  onClick: goToNext,
                  disabled: !canNavigate.value
                }, _hoisted_23, 8, _hoisted_21),
                _createElementVNode("button", {
                  class: "btn-prev",
                  onClick: goToPrev,
                  disabled: !canNavigate.value
                }, _hoisted_26, 8, _hoisted_24),
                _createElementVNode("button", {
                  class: "btn-skipstar",
                  onClick: goToFirst,
                  disabled: !canNavigate.value
                }, _hoisted_29, 8, _hoisted_27),
                _createElementVNode("button", {
                  class: "btn-skipend",
                  onClick: goToLast,
                  disabled: !canNavigate.value
                }, _hoisted_32, 8, _hoisted_30)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("form", null, [
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createElementVNode("div", _hoisted_40, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.cliente) = $event)),
                        readonly: onlyRead.value
                      }, null, 8, _hoisted_41), [
                        [_vModelText, formData.value.cliente]
                      ])
                    ]),
                    _hoisted_42,
                    _createElementVNode("div", _hoisted_43, [
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select form-select-sm",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.status) = $event)),
                        disabled: onlyRead.value
                      }, [
                        _createElementVNode("option", null, _toDisplayString(formData.value.status), 1),
                        _hoisted_45,
                        _hoisted_46
                      ], 8, _hoisted_44), [
                        [_vModelSelect, formData.value.status]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _createElementVNode("div", _hoisted_49, [
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select form-select-sm",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.code_id) = $event)),
                        disabled: onlyRead.value
                      }, [
                        _createElementVNode("option", null, _toDisplayString(formData.value.code_id), 1),
                        _hoisted_51,
                        _hoisted_52
                      ], 8, _hoisted_50), [
                        [_vModelSelect, formData.value.code_id]
                      ])
                    ]),
                    _hoisted_53,
                    _createElementVNode("div", _hoisted_54, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.nombre_comercial) = $event)),
                        readonly: onlyRead.value
                      }, null, 8, _hoisted_55), [
                        [_vModelText, formData.value.nombre_comercial]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _hoisted_57,
                    _createElementVNode("div", _hoisted_58, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.razon_social) = $event)),
                        readonly: onlyRead.value
                      }, null, 8, _hoisted_59), [
                        [_vModelText, formData.value.razon_social]
                      ])
                    ]),
                    _hoisted_60,
                    _createElementVNode("div", _hoisted_61, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.id_legal) = $event)),
                        readonly: onlyRead.value
                      }, null, 8, _hoisted_62), [
                        [_vModelText, formData.value.id_legal]
                      ])
                    ]),
                    _hoisted_63,
                    _createElementVNode("div", _hoisted_64, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.digito_vf) = $event)),
                        readonly: onlyRead.value
                      }, null, 8, _hoisted_65), [
                        [_vModelText, formData.value.digito_vf]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _hoisted_67,
                    _createElementVNode("div", _hoisted_68, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.barrio) = $event)),
                        readonly: onlyRead.value
                      }, null, 8, _hoisted_69), [
                        [_vModelText, formData.value.barrio]
                      ])
                    ]),
                    _hoisted_70,
                    _createElementVNode("div", _hoisted_71, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.ubicacion) = $event)),
                        readonly: onlyRead.value
                      }, null, 8, _hoisted_72), [
                        [_vModelText, formData.value.ubicacion]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _hoisted_74,
                    _createElementVNode("div", _hoisted_75, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.email) = $event)),
                        readonly: onlyRead.value
                      }, null, 8, _hoisted_76), [
                        [_vModelText, formData.value.email]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _hoisted_78,
                    _createElementVNode("div", _hoisted_79, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.telefono1) = $event)),
                        readonly: onlyRead.value
                      }, null, 8, _hoisted_80), [
                        [_vModelText, formData.value.telefono1]
                      ])
                    ]),
                    _hoisted_81,
                    _createElementVNode("div", _hoisted_82, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.telefono2) = $event)),
                        readonly: onlyRead.value
                      }, null, 8, _hoisted_83), [
                        [_vModelText, formData.value.telefono2]
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("div", _hoisted_85, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light btn-sm",
                  onClick: toggleSearch,
                  disabled: !canUseGroup2.value
                }, _toDisplayString(ButtonText.value), 9, _hoisted_86),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light btn-sm",
                  onClick: resetAll,
                  disabled: !canUseGroup2.value
                }, _toDisplayString(ButtonText2.value), 9, _hoisted_87)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})